import { ADSLINK_CREATE_ACTIONS, ADSLINK_DELETE_ACTIONS, ADSLINK_UPDATE_ACTIONS, ADSLINK_LIST_ACTIONS, ADSLINK_INACTIVE_ACTIONS } from "../../../actionType/admin/adsLink";


const intialState = {
  adslinkCreateData: {},
  isAdsLinkCreateLoader: false,
  adsLinkList: [],
  isAdsLinkListListLoader: false,
  adminPostDeleteLoader: false,
  adminAdsInavtiveLoader: false,
  portfoliosDeleteData: {},
  portfoliosInactiveData: {},
};

export const adsLinkReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case ADSLINK_CREATE_ACTIONS.ADSLINK_CREATE_REQUEST:
      return { ...state, isAdsLinkCreateLoader: true };
    case ADSLINK_CREATE_ACTIONS.ADSLINK_CREATE_RESPONSE:
      return {
        ...state,
        adslinkCreateData: payload,
        isAdsLinkCreatLoader: false,
      };
    case ADSLINK_CREATE_ACTIONS.ADSLINK_CREATE_ERROR:
      return {
        ...state,
        adslinkCreateData: payload,
        isAdsLinkCreateLoader: false,
      };

    // ADMINPOST_LIST_ACTIONS

    case ADSLINK_LIST_ACTIONS.ADSLINK_LIST_REQUEST:
      return { ...state, isAdsLinkListListLoader: true };
    case ADSLINK_LIST_ACTIONS.ADSLINK_LIST_RESPONSE:
      return {
        ...state,
        adsLinkList: payload,
        isAdsLinkListListLoader: false,
      };
    case ADSLINK_LIST_ACTIONS.ADSLINK_LIST_ERROR:
      return {
        ...state,
        adsLinkList: payload,
        isAdsLinkListListLoader: false,
      };

    // ADMINPOST_EDIT_ACTIONS

    case ADSLINK_UPDATE_ACTIONS.ADSLINK_UPDATE_REQUEST:
      return { ...state, isAdminPostCreatLoader: true };
    case ADSLINK_UPDATE_ACTIONS.ADSLINK_UPDATE_RESPONSE:
      return {
        ...state,
        adminPostCreatData: payload,
        isAdminPostCreatLoader: false,
      };
    case ADSLINK_UPDATE_ACTIONS.ADSLINK_UPDATE_ERROR:
      return {
        ...state,
        adminPostCreatData: payload,
        isAdminPostCreatLoader: false,
      };
    // ADMINPOST_DELETE_ACTIONS

    case ADSLINK_DELETE_ACTIONS.ADSLINK_DELETE_REQUEST:
      return { ...state, adminPostDeleteLoader: true };
    case ADSLINK_DELETE_ACTIONS.ADSLINK_DELETE_RESPONSE:
      return {
        ...state,
        portfoliosDeleteData:payload,
        adminPostDeleteLoader: false,
      };
    case ADSLINK_DELETE_ACTIONS.ADSLINK_DELETE_ERROR:
      return {
        ...state,
        portfoliosDeleteData:payload,
        adminPostDeleteLoader: false,
      };
    // ADMINPOST_INACTIVE_ACTIONS

    case ADSLINK_INACTIVE_ACTIONS.ADSLINK_INACTIVE_REQUEST:
      return { ...state, adminAdsInavtiveLoader: true };
    case ADSLINK_INACTIVE_ACTIONS.ADSLINK_INACTIVE_RESPONSE:
      return {
        ...state,
        portfoliosInactiveData:payload,
        adminAdsInavtiveLoader: false,
      };
    case ADSLINK_INACTIVE_ACTIONS.ADSLINK_INACTIVE_ERROR:
      return {
        ...state,
        portfoliosInactiveData:payload,
        adminAdsInavtiveLoader: false,
      };
    default:
      return state;
  }
};
